import { initObservability } from "@freightsimple/observability/observability";
import { apiServerUrl, Environment, getEnvironment } from "@/Environment";

const env = getEnvironment();
if (env !== Environment.Local) {
  initObservability({
    serviceName: "dashboard",
    environment: env,
    apiBaseUrl: apiServerUrl(),
  });
}
